import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link as RouterLink } from "react-router-dom";
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Link,
} from "@mui/material";
import { authAPI } from "../services/api";
import { useTranslation } from "react-i18next";

const EmailVerification = () => {
  const { t } = useTranslation();
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        await authAPI.verifyEmail(token);
        setStatus("success");
        setTimeout(() => navigate("/login"), 3000);
      } catch (error) {
        setStatus("error");
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: 3,
      }}
      >
      {status === "verifying" && (
        <>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>{t("auth.verification.verifying")}</Typography>
        </>
      )}
      {status === "success" && (
        <>
          <Alert severity="success">{t("auth.verification.success")}</Alert>
          <Typography sx={{ mt: 2 }}>
            {t(
              "auth.verification.redirectMessage",
              "You will be redirected to login in a moment, or "
            )}
            <Link component={RouterLink} to="/login">
              {t("auth.verification.clickHere", "click here")}
            </Link>
            .
          </Typography>
        </>
      )}
      {status === "error" && (
        <Alert severity="error">{t("auth.verification.error")}</Alert>
      )}
    </Box>
  );
};

export default EmailVerification;
